const DATA_KEY_HINTS: Record<string, string> = {
  technician: "Name",
  intervention_creation: "Date / Time",
  intervention_real_start: "Date / Time",
  intervention_real_end: "Date / Time",
  van: "Identification number",
  applicant: "Name",
  workorder_reference: "",
  intervention_address: "",
  on_call_duty: "Y / N",
  wo_type: "",
  wo_origin: "",
  contact_on_site_name: "",
  contact_on_site_number: "",
  wo_notes: "",
  scheduled_start: "Date / Time",
  scheduled_end: "Date / Time",
  planner: "Name",
  customer: "",
  purchaseOrderNumber: "",
};

const ALLOWED_ATTRIBUTE_DATA_KEYS = new Set(Object.keys(DATA_KEY_HINTS));

const PATH_TO_DATA_KEY: Record<string, string> = {
  technician: "technician",
  "technician.van.name": "van",
  applicant: "applicant",
  intervention_creation: "intervention_creation",
  intervention_real_start: "intervention_real_start",
  intervention_real_end: "intervention_real_end",
  ref: "workorder_reference",
  address: "intervention_address",
  onCallDuty: "on_call_duty",
  "type.label": "wo_type",
  "origin.label": "wo_origin",
  notes: "wo_notes",
  "schedule.start": "scheduled_start",
  "schedule.end": "scheduled_end",
  planner: "planner",
  "onSiteContact.name": "contact_on_site_name",
  "onSiteContact.phone": "contact_on_site_number",
  "purchaseOrderNumber": "purchaseOrderNumber",
};

const PATH_PREFIX_TO_DATA_KEY: { prefix: string; dataKey: string }[] = [
  {prefix: "customer.", dataKey: "customer"},
];

const IGNORED_ATTRIBUTE_PATHS = new Set(["time.start", "time.end"]);

export function getAttributeDataKey(path: string): string | undefined {
  if (PATH_TO_DATA_KEY[path]) {
    return PATH_TO_DATA_KEY[path];
  }

  const prefixMatch = PATH_PREFIX_TO_DATA_KEY.find(({prefix}) =>
    path.startsWith(prefix)
  );

  return prefixMatch?.dataKey;
}

export function isAttributeAllowed(path: string): boolean {
  if (IGNORED_ATTRIBUTE_PATHS.has(path)) {
    return false;
  }

  const dataKey = getAttributeDataKey(path);
  return dataKey !== undefined && ALLOWED_ATTRIBUTE_DATA_KEYS.has(dataKey);
}

export function getAttributeHint(path: string): string {
  const dataKey = getAttributeDataKey(path);

  if (!dataKey) {
    return "";
  }

  return DATA_KEY_HINTS[dataKey] ?? "";
}

export function getReportDataHint(val: string): string {
  if (IGNORED_ATTRIBUTE_PATHS.has(val)) {
    return "";
  }

  return isAttributePath(val) ? getAttributeHint(val) : "custom field";
}

export function isAttributePath(val: string): boolean {
  if (IGNORED_ATTRIBUTE_PATHS.has(val)) {
    return false;
  }
  if (getAttributeDataKey(val)) {
    return true;
  }

  return (
    val.includes(".") ||
    [
      "technician",
      "applicant",
      "intervention_creation",
      "intervention_real_start",
      "intervention_real_end",
      "ref",
      "address",
      "onCallDuty",
      "notes",
      "planner",
      "purchaseOrderNumber",
    ].includes(val)
  );
}
